const main = document.querySelector("div[data-page='ai']");

if (main) {
    /* scroll-animations */
    const scrollAnimation = () => {
        document.addEventListener('DOMContentLoaded', function () {
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('fade-in-up');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);
            const cards = document.querySelectorAll('.project-card');
            cards.forEach(function (card, index) {
                card.style.animationDelay = (index * 0.1) + 's';
                observer.observe(card);
            });
        });
    }

    const cardInteractions = () => {
        document.addEventListener('DOMContentLoaded', function () {
            const cards = document.querySelectorAll('.project-card');
            cards.forEach(function (card) {
                card.addEventListener('click', function () {
                    const title = this.querySelector('h3').textContent;
                    console.log('点击了项目:', title);
                });
                card.addEventListener('touchstart', function () {
                    this.style.transform = 'translateY(-4px) scale(0.98)';
                });
                card.addEventListener('touchend', function () {
                    this.style.transform = '';
                });
            });
        });
    }

    const navbarScrollEffect = () => {
        document.addEventListener('DOMContentLoaded', function () {
            const nav = document.querySelector('nav');
            let lastScrollY = window.scrollY;
            window.addEventListener('scroll', function () {
                if (window.scrollY > 100) {
                    nav.classList.add('shadow-sm');
                } else {
                    nav.classList.remove('shadow-sm');
                }
                lastScrollY = window.scrollY;
            });
        });
    }

    scrollAnimation();
    cardInteractions();
    navbarScrollEffect();

}